export default __webpack_public_path__ + "static/media/NewEvent.85e20dd7.PNG";